export default __webpack_public_path__ + "static/media/1(5).82603e48.jpg";